import http from "../http-common"

class GetBooksAndBestsellersService {
    getAllGetBooksAndBestsellers(path: string) {
        return http.get(`/education/getbooks-and-bestsellers/${path}`)
    }
}


export default new GetBooksAndBestsellersService();